import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { clearContent } from '../redux/contentSlice';

export default function ContentResetWatcher() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    // Only clear if not in /classroom
    if (!location.pathname.startsWith('/classroom')) {
      dispatch(clearContent());
    }
  }, [location, dispatch]);

  return null;
}
